<div class="flex items-center gap-3 bg-main text-white py-4 px-6 rounded-t">
  <mat-icon class="dialog-header__icon">engineering</mat-icon>
  <span class="text-[1.05rem] font-bold tracking-[0.2px] !p-0 !m-0 text-white">
    {{ messages.title | translateProp }}
  </span>
</div>

<mat-dialog-content class="!pt-5">
  <p class="mb-4 text-gray-700 leading-[1.65] text-[0.95rem]">
    {{ messages.body | translateProp }}
  </p>

  <div class="bg-subtitles border-l-4 border-main rounded-md py-3 px-[14px] flex items-start gap-2">
    <mat-icon class="dialog-content__resume-icon">event_available</mat-icon>
    <span class="text-sm text-main font-medium leading-[1.5]">{{ messages.resumeDate | translateProp }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" class="bg-main" (click)="close()">
    {{ messages.actionClose | translateProp }}
  </button>
</mat-dialog-actions>
